import { render, staticRenderFns } from "./moveMrn.vue?vue&type=template&id=a943616e"
import script from "./moveMrn.vue?vue&type=script&lang=js"
export * from "./moveMrn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports